import React from 'react';
import AuthFlowContainer from '../../components/openplay/AuthFlowContainer';
import ServiceIntroductionInteractive from './components/ServiceIntroductionInteractive';

const ServiceIntroductionPage = () => {
  return (
    <AuthFlowContainer showNavigation={true} currentStep="intro">
      <ServiceIntroductionInteractive />
    </AuthFlowContainer>
  );
};

export default ServiceIntroductionPage;
